import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsertDriveFileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insert_drive_file"}/>
}
